import moment from 'moment';

export const filters = () => {
    return {
        contact_id: null,
        dates: [
            moment().add('month', -1).format('YYYY-MM-DD'),
            moment().add('day', -1).format('YYYY-MM-DD')
        ],
        line_id: null
    };
};


export default {
    preloader: false,
    filters: filters(),
    contacts: [],
    lines: []
};



// WEBPACK FOOTER //
// ./src/modules/replacement_points_of_sale/state.js